import React from 'react';
import { useParams } from 'react-router-dom';
import NavbarUni from '../componentes/headUni';
import BodyProductUni from './componenetes/bodyProduct';
import BarCar from '../componentes/barCar';

function VerProductUni() {
    const { idCategoria } = useParams(); // Obtener idCategoria de la URL no es id si no nom
    
    return (
        <>
            {/* Contenido de la página */}
            <div style={{ paddingTop: '80px' }}>
                <NavbarUni />
                <BarCar />
                <div>
                    <BodyProductUni idCategoria={idCategoria}  />
                </div>
            </div>
        </>
    );
}

export default VerProductUni;
